export default __webpack_public_path__ + "src/images/packages/the-coconut-shell/4fb8f877d5736ad3769a4d7e0e83a368-5.jpg";